import React from "react";
import { connect } from "react-redux";
import type { RouteComponentProps } from "react-router";

import PageLoadingBar from "pages/common/PageLoadingBar";
import { retryPromise } from "utils/AppsmithUtils";
import type { InitWorkflowEditorPayload } from "ee/actions/workflowActions";
import { initWorkflowEditor } from "ee/actions/workflowActions";

type WorkflowEditorLoaderProps = RouteComponentProps<{
  workflowId: string;
}> & {
  initEditor: (payload: InitWorkflowEditorPayload) => void;
};
interface WorkflowEditorLoaderState {
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Editor: React.JSXElementConstructor<any> | null;
}

class WorkflowEditorLoader extends React.Component<
  WorkflowEditorLoaderProps,
  WorkflowEditorLoaderState
> {
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);

    this.state = {
      Editor: null,
    };
  }

  componentDidMount() {
    const { initEditor, match } = this.props;
    const { workflowId } = match.params;

    initEditor({ workflowId });

    retryPromise(
      async () => import(/* webpackChunkName: "editor" */ "./index"),
    ).then((workflow) => {
      this.setState({ Editor: workflow.default });
    });
  }

  render() {
    const { Editor } = this.state;
    return Editor ? <Editor {...this.props} /> : <PageLoadingBar />;
  }
}

// TODO: Fix this the next time the file is edited
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: any) => {
  return {
    initEditor: (payload: InitWorkflowEditorPayload) =>
      dispatch(initWorkflowEditor(payload)),
  };
};

export default connect(null, mapDispatchToProps)(WorkflowEditorLoader);
